import { applyMiddleware, compose, createStore } from 'redux';
import { createReducerManager } from '../data/reducerManager';
import thunkMiddleware from 'redux-thunk';
import { coreReducers } from '../data';

const reducerManager = createReducerManager(coreReducers);

const configureStoreDev = (initialState) => {
	const middlewares = [
		thunkMiddleware,
		// createLogger({
		// 	collapsed: true
		// }),
	];

	const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

	return createStore(reducerManager.reduce, initialState, composeEnhancers(applyMiddleware(...middlewares)));
};

const configureStoreProd = (initialState) => {
	const middlewares = [thunkMiddleware];

	return createStore(reducerManager.reduce, initialState, compose(applyMiddleware(...middlewares)));
};

const compactConfig = ['production', 'test'];
const exportedStore = compactConfig.includes(process.env.NODE_ENV) ? configureStoreProd() : configureStoreDev();
exportedStore.reducerManager = reducerManager;

export default exportedStore;
